import Header from "./landing/Header";
import Hero from "./landing/Hero";
import Presence from "./landing/Presence";
import Roles from "./landing/Roles";
import Audiences from "./landing/Audiences";
import WaitlistSection from "./landing/WaitlistSection";
import Footer from "./landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-teamie-bg" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Presence />
        <Roles />
        <Audiences />
        <WaitlistSection />
      </main>
      <Footer />
    </div>
  );
}
